<template>
	
</template>

<script>
	import * as types from '@/stores/mutation-types'

	export default {
		data () {
			return {

			}
		},
		computed: {
			errorMsg () {
				return this.$store.getters.errorMsg 
			},
			infoMsg () {
				return this.$store.getters.infoMsg 
			},
			successMsg () {
				return this.$store.getters.successMsg 
			},
			loadingMsg () {
				return this.$store.getters.loadingMsg
			}
		},
		watch: {
			errorMsg (msg) {
				if (msg !== '') {
					this.$swal({
						title: "อุ๊ปปส์!",
						text: msg,
						type: "error"
					})
					this.$nextTick(() => {
						this.$store.commit(types.SET_ERROR_MSG, '')
					})
				}
			},
			infoMsg (msg) {
				if (msg !== '') {
					this.$swal({
						// title: "อุ๊ปปส์!",
						text: msg,
						type: "info"
					})
					this.$nextTick(() => {
						this.$store.commit(types.SET_INFO_MSG, '')
					})
				}
			},
			successMsg (msg) {
				if (msg !== '') {
					this.$swal({
						title: "Success",
						text: msg,
						type: "success",
						timer: 2000
					})
					this.$nextTick(() => {
						this.$store.commit(types.SET_SUCCESS_MSG, '')
					})
				}
			}
		}
	}
</script>